import { render, staticRenderFns } from "./SimpleLoginForm.vue?vue&type=template&id=33b110a1&scoped=true&"
import script from "./SimpleLoginForm.vue?vue&type=script&lang=js&"
export * from "./SimpleLoginForm.vue?vue&type=script&lang=js&"
import style0 from "./SimpleLoginForm.vue?vue&type=style&index=0&id=33b110a1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b110a1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VForm,VTextField})
